import { useEffect } from 'react'

export function useKeyboardShortcuts(
	shortcuts: Record<string, () => void>,
	enabled: boolean,
) {
	useEffect(() => {
		function handleKeyDown(event: KeyboardEvent) {
			if (!enabled) {
				return
			}
			// Check if cmd/ctrl key is pressed
			const isCmdOrCtrl = event.metaKey || event.ctrlKey
			if (isCmdOrCtrl) {
				const key = event.key.toLowerCase()
				// Check if the pressed key combination matches any of our shortcuts
				if (shortcuts[key]) {
					event.preventDefault() // Prevent default browser behavior
					shortcuts[key]()
				}
			}
		}

		// Add event listener when component mounts
		window.addEventListener('keydown', handleKeyDown)

		// Clean up event listener when component unmounts
		return () => {
			window.removeEventListener('keydown', handleKeyDown)
		}
	}, [shortcuts])
}
